// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.is-data-invalid[data-v-0f78a98d] {\n    border: 1px solid red;\n    border-radius: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
